// Layout
import { DefaultLayout } from '../layouts';

// EUI Pages
import MyAccount from '../pages/my-account/myaccountindex.js';
export const appRoutes = [
	{
		path: '/my-account',
		element: MyAccount,
		layout: DefaultLayout,
		secure: true
	}

];
